<template>
  <v-select
    id="urs-select"
    v-model="filter.gerente"
    name="urs"
    item-text="gerente"
    item-name="gerente"
    item-value="id_unidade_regional"
    :items="urs"
    :label="title"
    :placeholder="title"
    v-on:change="$emit('onChange', filter.gerente)"
    :disabled="disabled"
    :multiple="multiple"
    clearable
    :return-object="true"
  >
    <template slot="no-data"> Nenhum Gerente </template>
  </v-select>
</template>

<script>
import { urAPI } from "../API/urAPI";
import { mapActions } from "vuex";

export default {
  name: "AppUrCombobox",
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    title: { type: String, default: "Gerentes" },
    defaultRepresentante: { type: String, default: null },
  },
  mounted() {
    this.loadUrs();
    document.getElementById("urs-select").removeAttribute("readonly");
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadUrs() {
      urAPI
        .getByUf(this.$store.state.uf)
        .then((resp) => {
          this.urs = resp.data.filter((item) => item.gerente);

          if (this.defaultRepresentante) {
            this.filter.gerente = this.urs.find(
              (item) => item.gerente.trim() == this.defaultRepresentante.trim()
            );
          }
        })

        .catch();
    },
  },
  data() {
    return {
      urs: [],
    };
  },
};
</script>
